import { Heading } from 'components/CommonComponents';
import { Grid, GridItem } from 'components/Grid';
import { ExportColours } from './ExportColours';
import { PAD_LARGE_NUMBER } from 'providers/designSystem';
import { ColourSetting } from './ColourSetting';

export const UserSettings = () => {
    return (
        <Grid numberOfColumns={1} gap={PAD_LARGE_NUMBER}>
            <Heading>Settings</Heading>
            <GridItem justifySelf="start">
                <ColourSetting />
            </GridItem>
            <GridItem justifySelf="start">
                <ExportColours />
            </GridItem>
        </Grid>
    );
};
